import { format, parseISO } from 'date-fns';
import { MeSnapshot } from '../../state/MeSnapshot';

/**
 * Проверяет, есть ли снимок MeSnapshot за сегодня
 */
export function hasMeSnapshotToday(snapshots: MeSnapshot[]): boolean {
    const today = format(new Date(), 'yyyy-MM-dd');
    return snapshots.some(snapshot => snapshot.date === today);
}

/**
 * Создаёт новый снимок MeSnapshot
 */
export function createMeSnapshot(
    wheelId: string,
    whoAmI: string,
    myMission: string,
    whoAmIRating: number,
    myMissionRating: number
): MeSnapshot {
    const now = new Date();
    return {
        uuid: crypto.randomUUID(),
        wheelId,
        timestamp: Date.now(),
        date: format(now, 'yyyy-MM-dd'),
        whoAmI,
        myMission,
        whoAmIRating,
        myMissionRating,
    };
}

/**
 * Находит снимок MeSnapshot для указанной даты
 * (снимок этой даты ИЛИ ближайший более ранний)
 */
export function findMeSnapshotForDate(
    snapshots: MeSnapshot[],
    date: Date
): MeSnapshot | null {
    const dateStr = format(date, 'yyyy-MM-dd');
    
    // Фильтруем снимки <= даты
    const relevantSnapshots = snapshots
        .filter(s => s.date <= dateStr)
        .sort((a, b) => b.timestamp - a.timestamp);
    
    return relevantSnapshots[0] || null;
}

/**
 * Находит снимки MeSnapshot на указанные даты для рефлексии
 * Использует ту же логику, что и findWheelSnapshotsForPeriod
 */
export function findMeSnapshotsForPeriod(
    snapshots: MeSnapshot[],
    dateFrom: Date,
    dateTo: Date
): { initial: MeSnapshot | null; final: MeSnapshot | null } {
    const fromDateStr = format(dateFrom, 'yyyy-MM-dd');
    const toDateStr = format(dateTo, 'yyyy-MM-dd');
    
    // Сортируем снимки по дате (возрастание - старые сначала)
    const sorted = [...snapshots].sort((a, b) => a.date.localeCompare(b.date));
    
    // Находим начальный снимок: максимальная дата <= dateFrom
    let initialSnapshot: MeSnapshot | null = null;
    for (let i = sorted.length - 1; i >= 0; i--) {
        if (sorted[i].date <= fromDateStr) {
            initialSnapshot = sorted[i];
            break;
        }
    }
    
    // Находим конечный снимок: максимальная дата <= dateTo
    let finalSnapshot: MeSnapshot | null = null;
    for (let i = sorted.length - 1; i >= 0; i--) {
        if (sorted[i].date <= toDateStr) {
            finalSnapshot = sorted[i];
            break;
        }
    }
    
    return { initial: initialSnapshot, final: finalSnapshot };
}
